// API
export const GET_COUNTIRES_LIST_API =
	'backoffice/dictionary/getCountriesWithCodes';

// Queries
export const QUERY_COUNTRIES = 'QUERY_COUNTRIES';
